var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 35,
    viewBox: "0 0 46 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_6449_35240)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6449_35240)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1.71094,
    width: 40,
    height: 28.5714,
    rx: 3.10982,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.71094H20.1429V15.0443H3V1.71094Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1429 1.71094L20.1429 3.6157H43V1.71094H20.1429ZM20.1429 5.52046V7.42522H43V5.52046H20.1429ZM20.1429 9.32998V11.2347H43V9.32998H20.1429ZM20.1429 13.1395L20.1429 15.0443H43V13.1395H20.1429ZM3 16.949V18.8538H43V16.949H3ZM3 20.7586V22.6633H43V20.7586H3ZM3 24.5681V26.4728H43V24.5681H3ZM3 28.3776V30.2824H43V28.3776H3Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90453 3.61566V5.52042H6.8093V3.61566H4.90453ZM8.71406 3.61566V5.52042H10.6188V3.61566H8.71406ZM12.5236 3.61566V5.52042H14.4283V3.61566H12.5236ZM16.3331 3.61566V5.52042H18.2379V3.61566H16.3331ZM14.4283 5.52042V7.42518H16.3331V5.52042H14.4283ZM10.6188 5.52042V7.42518H12.5236V5.52042H10.6188ZM6.8093 5.52042V7.42518H8.71406V5.52042H6.8093ZM4.90453 7.42518V9.32995H6.8093V7.42518H4.90453ZM8.71406 7.42518V9.32995H10.6188V7.42518H8.71406ZM12.5236 7.42518V9.32995H14.4283V7.42518H12.5236ZM16.3331 7.42518V9.32995H18.2379V7.42518H16.3331ZM4.90453 11.2347V13.1395H6.8093V11.2347H4.90453ZM8.71406 11.2347V13.1395H10.6188V11.2347H8.71406ZM12.5236 11.2347V13.1395H14.4283V11.2347H12.5236ZM16.3331 11.2347V13.1395H18.2379V11.2347H16.3331ZM14.4283 9.32995V11.2347H16.3331V9.32995H14.4283ZM10.6188 9.32995V11.2347H12.5236V9.32995H10.6188ZM6.8093 9.32995V11.2347H8.71406V9.32995H6.8093Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_6449_35240",
    x: 0.667638,
    y: 0.933483,
    width: 44.6647,
    height: 33.235,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55491
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16618
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0.278431 0 0 0 0 0.298039 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6449_35240"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0971817
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0.278431 0 0 0 0 0.298039 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6449_35240",
    result: "effect2_dropShadow_6449_35240"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6449_35240",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6449_35240"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1.71094,
    width: 40,
    height: 28.5714,
    rx: 3.10982,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "assets/20250410153110/media/usa.856a87d70c4e4ec74b2d133fc16c8883.svg";
export { ForwardRef as ReactComponent };